import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { articlesData } from '../../mocks/articles';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/base/SEO';

export default function ArticlesPage() {
  const navigate = useNavigate();
  
  // Makaleleri tarihe göre sırala (en yeni en üstte)
  const sortedArticles = [...articlesData].sort((a, b) => {
    const dateA = new Date(a.date.replace(/(\d+)\s+(\w+)\s+(\d+)/, '$2 $1, $3'));
    const dateB = new Date(b.date.replace(/(\d+)\s+(\w+)\s+(\d+)/, '$2 $1, $3'));
    return dateB.getTime() - dateA.getTime();
  });
  
  const featuredArticle = sortedArticles[0]; // En yeni makale öne çıkan olsun
  const sideArticles = sortedArticles.slice(1, 3);
  const restArticles = sortedArticles.slice(3);

  const handleArticleClick = (id: number) => {
    navigate(`/makale/${id}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Psikoloji Makaleleri ve Blog | Çocuk Gelişimi"
        description="Çocuk psikolojisi, ergen gelişimi, ebeveynlik ve aile dinamikleri üzerine uzman makaleleri. Çocuk gelişimi, duygusal sağlık ve ebeveynlik ipuçları."
        keywords="psikoloji makaleleri, çocuk gelişimi, ergen psikolojisi, ebeveynlik, aile danışmanlığı, çocuk yetiştirme"
        canonical="https://psikologesraerten.com/makaleler"
      />
      <Navbar />

      <section className="pt-32 pb-12 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl lg:text-6xl font-light text-gray-900 mb-4">Blog & Makaleler</h1>
          <p className="text-lg text-gray-600">Psikoloji ve kişisel gelişim üzerine yazılar</p>
        </div>
      </section>

      <section className="py-12 px-6 lg:px-8 pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
            {featuredArticle && (
              <div 
                onClick={() => handleArticleClick(featuredArticle.id)}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
              >
                <div className="h-96 overflow-hidden">
                  <img
                    src={featuredArticle.image}
                    alt={featuredArticle.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-8">
                  <span className="inline-block px-4 py-1.5 bg-teal-500 text-white text-xs font-medium rounded-full mb-4">
                    {featuredArticle.category}
                  </span>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4 leading-snug">
                    {featuredArticle.title}
                  </h2>
                  <p className="text-gray-600 mb-6 leading-relaxed">{featuredArticle.excerpt}</p>
                  <div className="flex items-center text-sm text-gray-400">
                    <span>{featuredArticle.date}</span>
                    <span className="mx-2">•</span>
                    <span>{featuredArticle.readTime}</span>
                  </div>
                </div>
              </div>
            )}

            <div className="space-y-8">
              {sideArticles.map((article) => (
                <div
                  key={article.id}
                  onClick={() => handleArticleClick(article.id)}
                  className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
                >
                  <div className="h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <span className="inline-block px-3 py-1 bg-blue-500 text-white text-xs font-medium rounded-full mb-3">
                      {article.category}
                    </span>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{article.title}</h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">{article.excerpt}</p>
                    <div className="flex items-center text-xs text-gray-400">
                      <span>{article.date}</span>
                      <span className="mx-2">•</span>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {restArticles.map((article) => (
              <div
                key={article.id}
                onClick={() => handleArticleClick(article.id)}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
              >
                <div className="h-56 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <span className="inline-block px-3 py-1 bg-amber-500 text-white text-xs font-medium rounded-full mb-3">
                    {article.category}
                  </span>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{article.title}</h3>
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center text-xs text-gray-400">
                    <span>{article.date}</span>
                    <span className="mx-2">•</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
